module.exports = __webpack_public_path__ + "img/store_tools.3667f0fa.png";